import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-04",
  "use": "icon-sheet_icon-04-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-04\"><g transform=\"translate(-178 -217)\"><path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M179.164 219.814l2.14.89.218 3.31.693 10.493h15.258l1.837-10.494h-17.545\" /><circle cx=\"184.5\" cy=\"238.5\" r=\"1.5\" /><circle cx=\"195.5\" cy=\"238.5\" r=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol